
<template>
  <div class="page-header">
    <div class="panel panel-default">
      <div class="panel-heading">拼团购简介</div>
      <div class="panel-body">
        <p class="p1">功能简介:</p>
        <p
          class="span1"
        >拼团购是目前微信圈最火爆的团购交易模块，支持粉丝组团购买，不同人数不同折扣，组团失败支持一键自动退款到用户微信钱包内。可以设置F多种团购折扣组合方式，用户可自由选择参团或者开团，粉丝可根据自己需要的折扣进行开团，开团后将团购页分享给好友，好友进入后直接进行参团。根据微信接口权限，已开通微信支付的公众号用户使用可以实现在线支付以及一键退款，如使用平台支付的用户可以实现在线支付，但无法实现一键退款。</p>
        <p class="p1">适用账号:</p>
        <p class="span1">服务号、订阅号、认证服务号、认证订阅号</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.panel-heading {
  font-weight: 600;
  font-size: 18px;
  color: #333;
  line-height: 20px;
  span {
    float: right;
  }
}
.panel-body {
  color: #666;
  .span1 {
    font-size: 16px;
    margin: 30px 0;
    color: #666;
    line-height: 32px;
    letter-spacing: 1px;
  }
  .p1 {
    margin: 30px 0;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    line-height: 32px;
    letter-spacing: 1px;
  }
}
</style>


